import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { setWidget } from '../../../actions';
import { useConfig, useWidget, useOptions, useExported } from '../../../selectors';
import { initializeWidget, updateWidgetDebounced } from '../../../services/widget-service';
import { WindowExtended } from '../../../types';
import { AfterExport } from '../AfterExport';

export const WidgetContainer = styled.div`
  height: 100%;
`;

export const Widget: FC = () => {
  const dispatch = useDispatch();
  const config = useConfig();
  const widget = useWidget();
  const options = useOptions();
  const exported = useExported();

  useEffect(() => {
    dispatch(setWidget(initializeWidget(window as unknown as WindowExtended)));
  }, [dispatch]);

  useEffect(() => {
    if (widget.instance && config.cloudName) {
      updateWidgetDebounced(widget.instance, config, options);
    }
  }, [widget, config, options]);

  return <>
    <WidgetContainer id="widget_container" hidden={exported.isExported} />
    {exported.isExported && <AfterExport url={exported.url || ''} />}
  </>;
};
